import React from 'react';
import { Box } from '@mui/material';
import { DSTypography, DSButton } from '../Forms';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            p: 4,
            bgcolor: 'var(--neutral-50)',
          }}
        >
          <Box
            sx={{
              p: 4,
              bgcolor: 'white',
              borderRadius: 'var(--radius-lg)',
              boxShadow: 'var(--shadow-lg)',
              maxWidth: '500px',
            }}
          >
            <DSTypography variant="h4" color="error" sx={{ mb: 2 }}>
              Something went wrong
            </DSTypography>
            <DSTypography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
              The application encountered an unexpected error. Please try refreshing the page or contact support if the problem persists.
            </DSTypography>
            {process.env.NODE_ENV === 'development' && (
              <Box
                sx={{
                  mt: 2,
                  mb: 4,
                  p: 2,
                  bgcolor: 'var(--neutral-100)',
                  borderRadius: 'var(--radius-sm)',
                  textAlign: 'left',
                  overflow: 'auto',
                  maxHeight: '200px',
                }}
              >
                <code style={{ fontSize: '0.8rem', color: 'var(--error-600)' }}>
                  {this.state.error?.toString()}
                </code>
              </Box>
            )}
            <DSButton
              variant="primary"
              onClick={() => window.location.reload()}
            >
              Reload Page
            </DSButton>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
